var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconSeat = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14.25 22.5C14.664 22.5 15 22.164 15 21.75L15.0405 19.5C17.5155 19.5 19.5 17.5485 19.5 15.0743C19.5 14.0265 18.5775 13.2173 17.5418 13.3665L12.474 14.166L9.78 7.431L10.575 3.56775C10.7865 2.49675 9.978 1.5 8.89425 1.5H6.21375C5.265 1.5 4.49925 2.274 4.49925 3.225V7.5L4.5135 7.647L6.7635 18.897C6.83325 19.2472 7.1415 19.5 7.49925 19.5H8.99925V21.75C8.99925 22.164 9.33525 22.5 9.74925 22.5C10.1633 22.5 10.4993 22.164 10.4993 21.75V19.5H13.4993V21.75C13.4993 22.164 13.8353 22.5 14.2493 22.5H14.25ZM15.0405 18H8.115L6 7.42575V3.225C6 3.099 6.09825 3 6.2145 3H8.895C9.0285 3 9.13275 3.129 9.105 3.27075L8.265 7.3485C8.235 7.4925 8.2485 7.64175 8.30325 7.77825L11.3033 15.2782C11.433 15.603 11.7705 15.795 12.1163 15.7402L17.7653 14.8492C17.8823 14.832 17.9993 14.9347 17.9993 15.0735C17.9993 16.7137 16.692 17.9993 15.0398 17.9993L15.0405 18Z", fill: "black" }))),
        alt: 'Seat',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconSeat;
//# sourceMappingURL=index.js.map